// スライドで計算
$(".slider").on("input", function () {
  let val = $(this).val();
  $(".js-count").each(function () {
    // データ属性の値を取得して、数値に変換する
    var value = parseFloat($(this).data("num"));
    var newValue = val * value;
    if (newValue % 1 !== 0) {
      newValue = newValue.toFixed(2);
    }
    // 掛け算して、データ属性を更新する
    var formattedValue = newValue
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    $(this).html(formattedValue);
    $("#multi-count span").each(function () {
      let valCount = $(this).data("count");
      $(this).removeClass("js-select");
      if ($(this).data("count") == val) {
        $(this).addClass("js-select");
      }
    });
  });
});
$(function () {
  //クリックで計算
  $("#multi-count span").click(function () {
    $("#multi-count span").removeClass("js-select");
    $(this).addClass("js-select");
    let val = $(this).data("count");
    $(".js-count").each(function () {
      // データ属性の値を取得して、数値に変換する
      var value = parseFloat($(this).data("num"));
      var newValue = val * value;
      if (newValue % 1 !== 0) {
        newValue = newValue.toFixed(2);
      }
      var formattedValue = newValue
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // 掛け算して、データ属性を更新する
      $(this).html(formattedValue);
      // sliderのvalue変更
      $(".slider").val(val);
    });
  });
});
$(document).ready(function () {
  var myElement = $("#multi-count .js-select");
  if (myElement.length) {
    let val = $("#multi-count .js-select").data("count");
    $(".js-count").each(function () {
      // // データ属性の値を取得して、数値に変換する
      var value = parseFloat($(this).data("num"));
      var newValue = val * value;
      if (newValue % 1 !== 0) {
        newValue = newValue.toFixed(2);
      }
      var formattedValue = newValue
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // 掛け算して、データ属性を更新する
      $(this).html(formattedValue);
      // sliderのvalue変更
      $(".slider").val(val);
    });
  }
});
// checkbox
$(".checknox-wrap input:checkbox").click(function () {
  if ($(this).is(":checked")) {
    $(this).parent("label").css("text-decoration", "line-through");
  } else {
    $(this).parent("label").css("text-decoration", "none");
  }
});

// toggle_btn
var noSleep = new NoSleep();
var wakeLockEnabled = false;
$(".toggle").click(function () {
  $(".toggle").toggleClass("checked");
  if (!$('input[name="check"]').prop("checked")) {
    $(".toggle input").prop("checked", true);
    $(".toggle .switch").text("ON");
  } else {
    $(".toggle input").prop("checked", false);
    $(".toggle .switch").text("OFF");
  }
  if (!wakeLockEnabled) {
    noSleep.enable(); // keep the screen on!
    wakeLockEnabled = true;
  } else {
    noSleep.disable(); // let the screen turn off.
    wakeLockEnabled = false;
  }
});

// popup
$(".image-popup").magnificPopup({
  type: "image",
  closeOnContentClick: true,
  mainClass: "mfp-img-mobile",
  image: {
    verticalFit: true,
  },
  gallery: {
    enabled: true,
  },
});

$(function () {
  //印刷ボタンをクリックした時の処理
  $(".print-btn").on("click", function () {
    //プリントしたいエリアの取得
    var printArea = document.getElementsByid("recipe");
  });
});
